import axios from 'axios';
import router from '../Routes';
import config from '../config';
import { firebaseApp, firestore } from '../main';
import * as firebase from 'firebase';

export default {
  namespaced: true,
  state: {
    users: [],
    selectedUsers: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null
  },
  mutations: {
    RECEIVED_USERS(state, payload) {
      state.users = payload;
      state.isReceiving = false;
    },
    SELECT_USERS(state, payload) {
      state.selectedUsers = payload;
    },
    RECEIVING_USERS(state) {
      state.isReceiving = true;
    },
    UPDATED_USER(state, payload) {
      let index = state.users.findIndex(p => p.id === payload.id);
      state = Object.assign(state, {
        users: state.users.map((p, i) => {
          if (i === index) {
            return Object.assign({}, p, payload);
          }
          return p;
        }),
        isUpdating: false
      });
    },
    UPDATING_USER(state) {
      state.isUpdating = true;
    },
    DELETED_USER(state, payload) {
      let indexToDelete = state.users.findIndex(p => p.id === payload.id);
      let users = [...state.users];
      users.splice(indexToDelete, 1);
      state = Object.assign(state, {
        users: [...users],
        isDeleting: false,
        idToDelete: null
      });
    },
    DELETING_USER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    }
  },
  actions: {
    selectUsers({commit}, payload) {
      commit('SELECT_USERS',payload);
    },
    syncWithAD({ dispatch }, payload) {
      const firebaseToken = localStorage.getItem('firebaseToken');
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + firebaseToken;
      axios
        .post(`${config.baseURLApi}/sync-ad`)
        .then(async res => {
          payload.$toasted.success('Sync done successfully!');
          const snapshot = await firestore
            .collection('users')
            .where('tenantId', '==', payload.tenantId)
            .get();
          const users = [];
          snapshot.docs.forEach(doc => {
            if (doc.data().active) {
              users.push(Object.assign({}, doc.data(), { id: doc.id }));
            }
          });
          dispatch('receiveUsers', users);
        })
        .catch(function(error) {
          console.log('Error on sync with AD ', error);
          payload.$toasted.error('Sync could not be done!');
        });
    },
    async getUsersByTenantRequest({ dispatch }, tenantId) {
      dispatch('receivingUsers');
      const snapshot = await firestore
        .collection('users')
        .where('tenantId', '==', tenantId)
        .get();
      const users = [];
      // debugger;
      snapshot.docs.forEach(doc => {
        if (doc.data().active) {
          users.push(Object.assign({}, doc.data(), { id: doc.id }));
        }
      });
      dispatch('receiveUsers', users);
    },
    getUsersRequest({ dispatch }) {
      dispatch('receivingUsers');
      firebaseApp
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
          axios
            .get('/console-users')
            .then(res => {
              dispatch('receiveUsers', res.data);
            })
            .catch(function(error) {
              console.log('Error on getting users', error);
              dispatch('receiveUsers', []);
              payload.$toasted.error('Users could not be retrieved!');
            });
        })
        .catch(function(error) {
          dispatch('receiveUsers', []);
          payload.$toasted.error('Users could not be retrieved!');
        });
    },
    updateUserRequest({ dispatch }, payload) {
      dispatch('updatingUser');
      firebaseApp
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
          axios
            .put('/console-users/' + payload.user.id, payload.user)
            .then(res => {
              dispatch('updateUser', res.data);
              router.push('/app/admin/user-management');
              payload.$toasted.success('User has been updated!');
            })
            .catch(function(error) {
              console.log('Error on updating user', error);
              dispatch('updateUser', {});
              payload.$toasted.error('User could not be updated!');
            });
        })
        .catch(function(error) {
          dispatch('updateUser', {});
          payload.$toasted.error('User could not be updated!');
        });
    },
    createUserRequest({ dispatch }, payload) {
      dispatch('updatingUser');
      firebaseApp
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
          axios
            .post('/console-users', payload.user)
            .then(res => {
              dispatch('updateUser', res.data);
              router.push('/app/admin/user-management');
              payload.$toasted.success('User has been created!');
            })
            .catch(function(error) {
              dispatch('updateUser', {});
              payload.$toasted.error('User could not be created!');
            });
        })
        .catch(function(error) {
          dispatch('updateUser', {});
          payload.$toasted.error('User could not be created!');
        });
    },
    deleteUserRequest({ dispatch }, payload) {
      dispatch('deletingUser', payload);
      firebaseApp
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
          axios
            .delete('/console-users/' + payload.id)
            .then(() => {
              dispatch('deleteUser', { id: payload.id });
              if (router.history.current.pathname !== '/app/admin/user-management') {
                router.replace('/');
                router.replace('/app/admin/user-management');
              }
              payload.$toasted.success('User has been deleted!');
            })
            .catch(function(error) {
              dispatch('deleteUser', {});
              payload.$toasted.error('User could not be deleted!');
            });
        })
        .catch(function(error) {
          dispatch('deleteUser', {});
          payload.$toasted.error('User could not be deleted!');
        });
    },
    receiveUsers({ commit }, payload) {
      commit('RECEIVED_USERS', payload);
    },
    receivingUsers({ commit }) {
      commit('RECEIVING_USERS');
    },
    updateUser({ commit }, payload) {
      commit('UPDATED_USER', payload);
    },
    updatingUser({ commit }) {
      commit('UPDATING_USER');
    },
    deleteUser({ commit }, payload) {
      commit('DELETED_USER', payload);
    },
    deletingUser({ commit }, payload) {
      commit('DELETING_USER', payload);
    }
  }
};
